import * as React from "react";

const LoaderContext = React.createContext({});

const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = React.useState();
  return (
    <LoaderContext.Provider value={[loading, setLoading]}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const context = React.useContext(LoaderContext);

  if (!context) {
    throw new Error(`useLoader must be used within a LoaderProvider`);
  }
  return context;
};

export default LoaderProvider;
